import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { FavouriteButton } from 'components/FavouriteButton'

import styles from './BookView.module.scss'

export function InjectFavouriteButton({ bookMode, bookProgress }) {
  const [container, setContainer] = useState<Element | null>(null)

  useEffect(() => {
    const title = document.querySelector('.book-cover > .button--default')
    if (!title) return

    if (title.parentElement?.classList.contains(styles.wrapper)) {
      setContainer(title.parentElement)
      return
    }

    const wrapper = document.createElement('div')
    wrapper.className = styles.wrapper

    title.parentNode?.insertBefore(wrapper, title)

    wrapper.appendChild(title)

    setContainer(wrapper)

    return () => {
      if (wrapper.parentNode && title) {
        wrapper.parentNode.insertBefore(title, wrapper)
        wrapper.remove()
      }
    }
  }, [])

  if (!container) return null

  return createPortal(
    <FavouriteButton className={styles['favourite-button']} bookMode={bookMode} bookProgress={bookProgress} />,
    container
  )
}
